export function isNull(value: any): boolean {
  if (value === null) {
    return true;
  }

  return false;
}
